import { v4 as uuidv4 } from "uuid";

import { useCollapsePanel } from "hooks/useCollapsePanel";

const CardBase = (props) => {
  const {
    additionalContent,
    ariaLabel,
    cardTitle,
    children,
    badgeClass = null,
    additionalChildComponent = null,
  } = props;

  const uuid = uuidv4();
  useCollapsePanel(uuid);

  return (
    <div className="ui-card mb-4 md:mb-6">
      <div className="md:flex md:flex-row md:items-start">
        <div className="px-4 pt-3 xl:px-6 xl:pt-6">
          <h2 className="mb-0">
            <button
              id={uuid}
              className="flex items-center group md:hidden"
              aria-controls={`${uuid}-panel`}
              aria-expanded="true"
              aria-label={ariaLabel}
            >
              <span className="inline-block p-1 rounded-full mr-2 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                <svg
                  className="ui-icon ui-plus w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-plus"></use>
                </svg>
                <svg
                  className="ui-icon ui-minus w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-minus"></use>
                </svg>
              </span>
              <span
                className={`text-base font-body font-bold md:ui-no-badge-icon-inline ${
                  badgeClass ? `ui-badge-inline-icon-${badgeClass}` : ""
                }`}
              >
                {cardTitle}
              </span>
            </button>
            <span className="text-xl font-body font-bold hidden md:block">
              {cardTitle}
            </span>
          </h2>
        </div>
        {additionalChildComponent && (
          <div className="px-4 pt-3 pr-6 xl:px-6 xl:pt-6 md:ml-auto">
            {additionalChildComponent}
          </div>
        )}
        <hr className="mb-0 mt-3 md:hidden" />
      </div>
      <hr className="hidden md:block" />
      <div
        id={`${uuid}-panel`}
        className="px-4 pb-4 overflow-hidden h-20 mt-4 md:h-auto md:mt-0 xl:px-6 xl:pb-6"
      >
        {children}
      </div>
      {additionalContent}
    </div>
  );
};

export default CardBase;
